var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { CellAlign } from '.';
import selectAllIcon from '../../../assets/images/icons/common/icon-claim-all.png';
export default function TableHead(_a) {
    var labels = _a.labels, selectAllRows = _a.selectAllRows;
    var showMobileExtendCell = labels.some(function (label) { return label.showExtendMobile; });
    return (_jsxs(Container, { children: [selectAllRows && (_jsx(CellContainer, { align: CellAlign.CENTER, size: 0.3, children: _jsx("button", { className: "select-all-button", onClick: selectAllRows, children: _jsx("img", { alt: "select-all", src: selectAllIcon }) }) })), labels
                .filter(function (label) { return !label.hidden; })
                .map(function (label, index) { return (_jsx(CellContainer, { actionCell: label.actionCell, align: label.align, className: label.hiddenMobile ? 'desktop-only' : '', mobileSize: label.mobileSize, size: label.size, children: _jsx("p", { children: label.label }) }, index)); }), showMobileExtendCell && _jsx(CellContainer, { align: CellAlign.CENTER, className: "mobile-only", size: 0.2 })] }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  flex-shrink: 0;\n  height: 48px;\n  justify-content: center;\n  width: 100%;\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  flex-shrink: 0;\n  height: 48px;\n  justify-content: center;\n  width: 100%;\n"])));
var CellContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex: ", ";\n  flex-direction: row;\n  height: 100%;\n  justify-content: ", ";\n  padding: ", ";\n\n  @media screen and (max-width: 824px) {\n    flex: ", ";\n  }\n\n  & > p {\n    font-size: 14px;\n    font-weight: 700;\n  }\n\n  .select-all-button {\n    background-color: ", ";\n    border-radius: 50%;\n    height: 24px;\n    padding: 2px;\n    width: 24px;\n\n    & > img {\n      height: 100%;\n      opacity: 0.7;\n      width: 100%;\n    }\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  flex: ", ";\n  flex-direction: row;\n  height: 100%;\n  justify-content: ", ";\n  padding: ", ";\n\n  @media screen and (max-width: 824px) {\n    flex: ", ";\n  }\n\n  & > p {\n    font-size: 14px;\n    font-weight: 700;\n  }\n\n  .select-all-button {\n    background-color: ", ";\n    border-radius: 50%;\n    height: 24px;\n    padding: 2px;\n    width: 24px;\n\n    & > img {\n      height: 100%;\n      opacity: 0.7;\n      width: 100%;\n    }\n  }\n"])), function (_a) {
    var size = _a.size;
    return size || '1';
}, function (_a) {
    var align = _a.align;
    switch (align) {
        case CellAlign.LEFT:
            return 'flex-start';
        case CellAlign.CENTER:
            return 'center';
        case CellAlign.RIGHT:
            return 'flex-end';
        default:
            return 'center';
    }
}, function (_a) {
    var align = _a.align;
    switch (align) {
        case CellAlign.LEFT:
            return '0 0 0 8px';
        case CellAlign.CENTER:
            return '0';
        case CellAlign.RIGHT:
            return '0 8px 0 0';
        default:
            return '0';
    }
}, function (_a) {
    var size = _a.size, mobileSize = _a.mobileSize, actionCell = _a.actionCell;
    if (actionCell)
        return 0.8;
    return mobileSize || size || '1';
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.layoutNeutral;
});
var templateObject_1, templateObject_2;
